export const moduleDownload = [
  {
    id:1,
    name:'calypso',
    summary:'calypso的PWmat接口，用于结构搜索',
    introduce:'',
    course:'calypso.pdf',
    download:'CalypsoPWmat.tar.gz',
    note:'&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp<a href="http://39.98.50.106/pwmat-resource/module-download/file/CalypsoPWmat2.0.tar.gz">CalypsoPWmat2.0.tar.gz</a><br/>示例：<a href="http://39.98.50.106/pwmat-resource/module-download/example/calypsopwmat.zip">calypsopwmat.zip</a>'
  },
  {
    id:2,
    name:'Absorption Spectrum',
    summary:'用于PWmat RT-TDDFT画光吸收谱',
    introduce:'',
    course:'plot_tddft_absorp.pdf',
    download:'',
    note:'plot_tddft_absorp.x已经添加最新的utility里面，用户可以直接更新PWmat程序（2018年12月7日之前的版本需要更新，之后的不需要），更新完成之后的utils里面就包括plot_tddft_absorp.x。'
  },
  {
    id:3,
    name:'band_alignment',
    summary:'用于计算band alignment',
    introduce:'',
    course:'band_alignment.pdf',
    download:'GaAs_AlAs_bandalignment.tar',
    note:''
  },
  {
    id:4,
    name:'pypwmat',
    summary:'用于defect（For bulk and defect)声子计算，请删除PWmat2Phonopy旧版本！',
    introduce:'',
    course:'PyPWmat.pdf',
    download:'PyPWmat-1.0.6.zip',
    note:'示例：<a href="http://39.98.50.106/pwmat-resource/module-download/example/SiO2.zip">SiO2</a>'
  },
  {
    id:5,
    name:'ELPWmat',
    summary:'用于弹性常数计算',
    introduce:'',
    course:'ELPWmat.pdf',
    download:'ELPWmat.tar.gz',
    note:''
  },
  {
    id:6,
    name:'Defect Level',
    summary:'用于defect level计算',
    introduce:'',
    course:'Defect_calculation.pdf',
    download:'',
    note:'示例：<a href="http://39.98.50.106/pwmat-resource/module-download/example/GaAs.64.defect.tar">GaAs.64.defect.tar</a'
  },
  {
    id:7,
    name:'TDDFT Carrier Cooling',
    summary:'用于TDDFT Carrier Cooling计算',
    introduce:'',
    course:'TDDFT_Carrier_cooling.pptx',
    download:'C2H6O2_TDDFT.tar',
    note:''
  },
  {
    id:8,
    name:'USPEX',
    summary:'USPEX的PWmat接口，用于结构搜索',
    introduce:'',
    course:'PWmatUSPEX接口安装使用教程.pdf',
    download:'PWmatUSPEX_v1.0.0.tar',
    note:''
  },
  {
    id:9,
    name:'CIF2CELL',
    summary:'PWmat与CIF2CELL的接口，可以用于atom.config与cif格式文件相互转化，更详细的功能可以参考CIF2CELL官网',
    introduce:'',
    course:'CIF2CELL简易教程.pdf',
    download:'cif2cell.tar',
    note:''
  },
  {
    id:10,
    name:'EMC',
    summary:'PWmat与EMC的接口，可以用于计算载流子的有效质量',
    introduce:'',
    course:'EMC.pdf',
    download:'EMC.tar.gz',
    note:''
  },
  {
    id:11,
    name:'BANDUP',
    summary:'PWmat与BANDUP的接口，可以用于将超晶胞的能带以原胞显示',
    introduce:'',
    course:'bandup.pdf',
    download:'',
    note:'示例：<a href="http://39.98.50.106/pwmat-resource/module-download/example/bulk_si.tar">bulk_si.tar</a>'
  },
  {
    id:12,
    name:'YAMBO',
    summary:'PWmat与YAMBO的接口，可以用于GW计算',
    introduce:'',
    course:'YAMBO_GW.pdf',
    download:'YAMBO.zip',
    note:'示例：<a href="http://39.98.50.106/pwmat-resource/module-download/example/GaAs_2atom_YAMBO.tar">GaAs_2atom_YAMBO.tar</a>'
  },
  {
    id:13,
    name:'Defect Nonradiative Decay',
    summary:'用于计算体系中缺陷的非辐射衰减过程',
    introduce:'',
    course:'defect_nonradiative.pdf',
    download:'nonradiative.zip',
    note:'示例：<a href="http://39.98.50.106/pwmat-resource/module-download/example/EXAMPLE_GaN.tar">EXAMPLE_GaN.tar</a>'
  }
]


